import { DesktopOutlined } from '@ant-design/icons';
import { Result } from 'antd';
import { useTranslation } from 'translations/hooks';

import { MobileSingleCardPageWithFilterLayout } from 'business/layout/single-card-page-with-filter-card/mobile';

export const NoMobileSupport = () => {
  const { t } = useTranslation();

  return (
    <MobileSingleCardPageWithFilterLayout>
      <Result
        icon={<DesktopOutlined />}
        title={t('errors.no_mobile_support.title')}
        subTitle={t('errors.no_mobile_support.subtitle')}
      />
    </MobileSingleCardPageWithFilterLayout>
  );
};
